import { render, staticRenderFns } from "./LoggedItemsListView.vue?vue&type=template&id=b2dfd006&scoped=true&"
import script from "./LoggedItemsListView.vue?vue&type=script&lang=js&"
export * from "./LoggedItemsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dfd006",
  null
  
)

export default component.exports